module.exports = __webpack_public_path__ + "static/thomas-bierlein-ebbd1332d6ca6092a4d14ffe03363a34.png";